import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ConsultarPagosModalViewDetailsComponent } from './modal-view-details/modal-view-details.component';

@Component({
  selector: 'app-consultar-pagos',
  templateUrl: './consultar-pagos.component.html',
  styleUrls: ['./consultar-pagos.component.scss'],
  providers: [SecurityService],
})
export class ConsultarPagosComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ConsultarPagosModalViewDetailsComponent, { static: true }) modalVerPago: ConsultarPagosModalViewDetailsComponent;

  // Form
  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  private currentPayload: any = null;
  loading: boolean = false;
  loadingExcel: boolean = false;
  listaMovimientos: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();
  optionsOrderConsulta: Array<any> = [];

  clienteSeleccionado: any = null;

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private pagoService: PagoService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('CONSULTAR-PAGOS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.optionsOrderConsulta = [
      { value: '1', label: 'Fecha Emisión' },
      { value: '2', label: 'Fecha Pago' },
      { value: '3', label: 'Monto' },
      { value: '4', label: 'Rut' },
    ];
    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      fecha_desde: [initDate, [Validators.required]],
      fecha_hasta: [currentDate, [Validators.required]],
      rutCliente: [null, []],
      codigo: [null, [Validators.required]],
      monto: [null, []],
      recorrido_codigo: [null, []],
      orden_envio: [0],
      es_liquidacion: false,
      pagado: false,
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });

    this.formHeader.get('orden_envio').valueChanges.subscribe((order) => {
      this.buscar(1);
    });
  }

  /********* MODAL CLIENTE *********/
  openModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data;
    this.formHeader.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut));
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null;
  }
  /********* MODAL CLIENTE *********/

  buscar(pageNumber: number = 1) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber;

    this.listaMovimientos = [];

    const { fecha_desde, fecha_hasta, codigo, monto, recorrido_codigo, es_liquidacion, pagado } = this.formHeader.value;
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fecha_desde ? fecha_desde : null,
        fecha_hasta: fecha_hasta ? fecha_hasta : null,
        cliente_proveedor_rut: this.clienteSeleccionado ? this.clienteSeleccionado.rut : -1,
        folio: codigo ? Number(codigo) : 0,
        monto: monto ? Number(monto) : 0,
        recorrido_codigo: recorrido_codigo ? Number(recorrido_codigo) : 0,
        orden_envio: this.formHeader.get('orden_envio').value,
        es_liquidacion,
        pagado
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.currentPayload = inputParams;

    this.loading = true;
    this.pagoService.obtenerPagosParaConsulta(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.paginationContext.RecordsCount = totalRegistros;
      this.paginationContext.CurrentPage = paginaActual;
      this.paginationContext.PagesCount = totalPaginas;
      this.listaMovimientos = registros;

      this.listaMovimientos.forEach((p) => {
        p.rutFormato = this.rutService.AgregarDV(p.cliente_proveedor_rut);
        p.rutRecaudadorFormato = this.rutService.AgregarDV(p.rut_recaudador);
      });

      this.loading = false;
    });
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage);
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;

    inputParams.entidad.retornaExcel = type === 'XLS';
    inputParams.entidad.retornaPDF = type === 'PDF';

    this.log('inputParams', JSON.stringify(inputParams));

    this.loadingExcel = true;
    this.pagoService.obtenerPagosParaConsultaExcel(inputParams, ({ mensajes, respuesta }) => {
      this.loadingExcel = false;
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo);
    });
  }

  loadAndShowPago({ codigo, folio, fecha_pago }) {
    console.log('numero de folio ', folio);
    this.modalVerPago.loadAndShow(codigo, folio, fecha_pago);
  }

  limpiarfiltros() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader.reset();
    this.formHeader.get('orden_envio').setValue(0);
    this.formHeader.get('fecha_desde').setValue(initDate);
    this.formHeader.get('fecha_hasta').setValue(currentDate);
    this.formHeader.get('rutCliente').setValue(null);
    this.formHeader.get('codigo').setValue(null);
    this.formHeader.get('monto').setValue(null);
    this.formHeader.get('recorrido_codigo').setValue(null);
    this.clienteSeleccionado = null;
  }
}
